import { Currency, CURRENCY_SYMBOLS, useCurrencyStore } from '../lib/currencyStore';

export function formatPrice(price: number | undefined | null, currency: Currency): string {
  if (typeof price !== 'number' || isNaN(price)) {
    return 'N/A';
  }

  const { exchangeRates } = useCurrencyStore.getState();
  
  // Convert USD price to target currency
  // Use the exchange rate if available, otherwise silently use 1 as fallback
  const rate = exchangeRates[currency];
  const convertedPrice = price * (typeof rate === 'number' ? rate : 1);

  // Format based on currency conventions
  let options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };

  // Special case for JPY - no decimal places
  if (currency === 'JPY') {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }

  try {
    return new Intl.NumberFormat('en-US', options).format(convertedPrice);
  } catch (error) {
    console.error(`Error formatting price for ${currency}:`, error);
    
    // Fallback formatting if Intl.NumberFormat fails
    if (currency === 'JPY') {
      return `${CURRENCY_SYMBOLS[currency]}${Math.round(convertedPrice)}`;
    }
    
    return `${CURRENCY_SYMBOLS[currency]}${convertedPrice.toFixed(2)}`;
  }
}